import Joi from 'joi';

export const leaveValidationSchema = Joi.object({
    leave_type_id: Joi.number()
        .required()
        .label('Leave type')
        .messages({
            'any.required': 'Leave type is required.',
            'number.base': 'Leave type is required.',
        }),
    leave_days: Joi.number()
        .required()
        .greater(0)
        .label('Leave days')
        .messages({
            'any.required': 'Leave days are required.',
            'number.greater': 'Leave days must be greater than zero.',
            'number.base': 'Leave days must be a number.',
        }),
    unuse_leave: Joi.string()
        .required()
        .valid('carried_forward', 'forfeited')
        .label('Unused leave type')
        .messages({
            'any.required': 'Unused leave type is required.',
            'string.empty': 'Unused leave type cannot be empty.', 
            'any.only': 'Unused leave type must be either "carried_forward" or "forfeited".',
        }),
    cf_limit: Joi.alternatives()
        .conditional('unuse_leave', {
            is: 'carried_forward',
            then: Joi.number()
                .required()
                .less(Joi.ref('leave_days'))
                .messages({
                    'any.required': 'CF limit is required when unused leave is carried forward',
                    'number.less': 'CF limit must be less than leave days',
                }),
            otherwise: Joi.any().allow(null).messages({
                'any.only': 'CF limit must be null if unused leave is forfeited',
            }),
        })
        .label('CF limit'),
});
